(function() {
  angular.module('benefits')
  .controller('printModalController', ['$uibModalInstance',  '$uibModal', '$scope','printBenefitsHelper', 'benefitInfoData',
    function($uibModalInstance, $uibModal, $scope, printHelper, benefitInfoData){
      var vm = this;
      vm.printableSections = [ {'name': 'Member Information', 'id':'memberInfoSection','checked': true, 'printableObjName' : 'memberInfo'} ,                               
                               {'name': 'Group Information' , 'id': 'groupInfoSection','checked': false, 'printableObjName' : 'groupInfo'} ,
                               {'name': 'Eligibility Information' , 'id': 'eligibilityInfoSection', 'checked': false, 'printableObjName' : 'eligibilityInfo' },
                               {'name': 'Insurance Information', 'id': 'insuranceInfoSection','checked': false, 'printableObjName' : 'insuranceInfo' },
                               {'name': 'Plan Information', 'id': 'planInfoSection','checked': false, 'printableObjName' : 'planInfo' },
                               //{'name': 'Procedure History', 'id': 'procedureHistory','checked': false, 'printableObjName' : 'procedureHistory' },
                               {'name': 'Service Value Statement', 'id': 'serviceValueStatement','checked': true, 'printableObjName' : 'serviceValueStatement' }
                            ];

      vm.printableProcedureCodes = [];
      vm.benefitInfo = benefitInfoData;
      vm.benefitCategories = [];
      let seachedProcCodes = _.sortBy(_.keys(printHelper.printableProcedureCodes()));
      _.each(seachedProcCodes,function(procedureCode) {
        vm.printableProcedureCodes.push({'name': procedureCode, 'id': procedureCode,'checked': false, 'printableObjName' : procedureCode });
      });
      if(vm.benefitInfo && vm.benefitInfo.categories && vm.benefitInfo.categories.length > 0){
          _.each(vm.benefitInfo.categories, function(cate, index) {
              vm.benefitCategories.push({'name': cate.name, 'id': cate.name,'checked': false, 'detailsChecked': false, 'printableObjName' : cate.name, 'printIndex': index });
           });
        }

      vm.allSummary = false;
      vm.allDetails = false;
      vm.includeAllSummary = function() {
        _.each(vm.printableSections,function(section) {
           if (_.indexOf(['memberInfoSection','serviceValueStatement'],section.id) === -1) {
             section.checked = vm.allSummary;
          }
        });
        _.each(vm.printableProcedureCodes,function(procedureCode) {             
        	procedureCode.checked = vm.allSummary;           
         });
        _.each(vm.benefitCategories,function(category) {             
        	category.checked = category.detailsChecked ? category.detailsChecked : vm.allSummary;           
         });        
      };
      vm.includeAllDetails = function() {
         _.each(vm.benefitCategories,function(category) {             
          	category.checked = vm.allDetails ? vm.allDetails : vm.allSummary;
          	category.detailsChecked = vm.allDetails;
         }); 
      };
      vm.checkCategorySummary = function(category){
    	  category.checked = vm.allSummary ? vm.allSummary : category.detailsChecked; 
      }
      
      vm.print = function () {
        $uibModalInstance.close({"sections":_.filter(vm.printableSections,['checked',true]),
                                 "procedureCodes": _.filter(vm.printableProcedureCodes,['checked',true]),
                                 "benefitCategories":_.filter(vm.benefitCategories,['checked',true])
                                 });
      };

      vm.close = function () {
        $uibModalInstance.dismiss();
      };
    }]);
})();
